
import {from as observableFrom,  Observable } from 'rxjs';
import { Injectable, OnInit, Directive } from '@angular/core';
import { LocalStorage, LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { Resource, ResourceParams } from '@ngx-resource/core';
//import { HttpClientModule } from '@ngx-resource/handler-ngx-http'
import { HttpHeaders, HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { CookieService } from 'ngx-cookie';
import {ModuleService} from './modules.service';
import { environment } from '../../environments/environment';
import { DialogService } from './dialog.service';
import { GlobalFlagsService } from './global-flags.service';
import { TranslateService } from '@ngx-translate/core';

interface IUserProfile {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  readonly userName: string;
}

interface ITokenRequest {
  grant_type: string;
  client_id: string;
  client_secret: string;
  username: string;
  password: string;
  scope: string;
}

interface IToken {
  access_token: string;
  expires_in: string;
  token_type;
  refresh_token: string;
  appModules: any;
  roles: any;
  lang: any;
  langCode: string;
  mfaEnabled: boolean;
}
@Directive()
@Injectable()
@ResourceParams({
  url: `${environment.url.api}`
})

@Injectable()
@ResourceParams({
  url: environment.url.authUrl + 'connect/'
})
export class OAuthService extends Resource implements OnInit {


  @LocalStorage()
  private static access_token;

  @LocalStorage()
  private static refresh_token;
  private static token: IToken;
  private static clientToken: IToken;
  private static downloadToken;
  private static appModules: any;
  private static lang: any;
  private static langCode: any;
  private static roles: any;
  private static instance: OAuthService;
  private phone : string;
  private username: string;

  public static isRefreshing = false;

  private statusObservable: Observable<boolean>;

  private statusSubject: Rx.Subject<boolean> = new Rx.Subject<boolean>();

  readonly REMEMBER_ME_COOKIE: string = 'remember';

  readonly USERNAME_COOKIE: string = 'usernames';

  readonly EMAIL_COOKIE: string = 'email';




  static isTakeUserToken(): boolean {
    return OAuthService.token !== null;
  }

  static getAccessToken(): string {
    if (OAuthService.access_token) {
      return OAuthService.access_token;
    }

    return '';
  }

  public static getAppModules() {
    return OAuthService.appModules;
  }

  public static getRoles() {
    return OAuthService.roles;
  }

  public static getLanguage() {
    return OAuthService.lang;
  }

  public static getLanguageCode(){
    return OAuthService.langCode;
  }

  static saveAppModules(appModules: any) {
    this.appModules = appModules;
    localStorage.setItem('modules', JSON.stringify(appModules));
  }

  static saveLanguage(lang: any) {
    this.lang = lang;
    localStorage.setItem('lang', JSON.stringify(lang));
  }

  static saveLanguageCode(langCode: any) {
    this.langCode = langCode;
    localStorage.setItem('langCode', JSON.stringify(langCode));
  }

  static saveRoles(roles: any) {
    this.roles = roles;
    localStorage.setItem('roles', JSON.stringify(roles));
  }

  static refreshToken(http: HttpClient): Observable<any> {
    OAuthService.isRefreshing = true;
    return Observable.create((observer) => {
      let refresh_token;
      if (OAuthService.token && OAuthService.token.refresh_token) {
        refresh_token = OAuthService.token.refresh_token;
      } else {
        refresh_token = OAuthService.refresh_token;
      }

      const body = `grant_type=refresh_token&client_id=iotrackerBrowser&refresh_token=${refresh_token}`;

      const headers = new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Authorization': 'Basic ' + btoa('angularClient:nowit346346')
      });
      http.post(environment.url.authUrl + 'oauth/token', body, { headers })
        .subscribe(
        (data: any) => {
          OAuthService.isRefreshing = false;
          OAuthService.token = <IToken>data.json();
          OAuthService.access_token = OAuthService.token.access_token;
          observer.next(<IToken>data.json());
        },
        (error: Response) => {
          OAuthService.isRefreshing = false;
          if (error.status === 400 || error.status === 401) {
            OAuthService.instance.logout(true);
          }
        });

    });

  }

  static getClientToken(http: HttpClient): Observable<any> {

    const observable: Observable<any> = new Observable(observer => {
      const param = new URLSearchParams();
      param.set('grant_type', 'password');
      param.set('clientId', 'angularClient');
      param.append('client_secret', 'nowit346346');
      param.append('scope', 'ipcsApi');

      const headers: HttpHeaders = new HttpHeaders();
      headers.append('content-type', 'application/x-www-form-urlencoded');

      http.post(environment.url.authUrl + 'oauth/token', param.toString(), { headers })
        .subscribe((data: any) => {
          OAuthService.clientToken = <IToken>data.json();
          observer.next(OAuthService.clientToken);
        },
        (error: any) => {
          console.log(error.json());
          observer.error(error.json());
        });
    });

    return observable;

  }

  constructor(private router: Router,
    private storage: LocalStorageService,
    protected http: HttpClient,
    private globalFlagsService: GlobalFlagsService,
    private dialogService: DialogService,
    private cookieService: CookieService,
    private moduleService: ModuleService,
    private translate: TranslateService,
    ) {
    super();
    OAuthService.instance = this;

    // test translate JSON
    this.translate.addLangs(['EN', 'FR', 'UR', 'ES', 'IT', 'FA', 'DE', 'ZH-CHS']);
        this.translate.setDefaultLang('EN');
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang.match(/EN|FR|UR|ES|IT|FA|DE|ZH-CHS/) ? browserLang : 'EN');
  }

  ngOnInit() {
    //why is this empty?
  }

  public authenticate(data : any) {
    OAuthService.token = <IToken>data;
    OAuthService.access_token = OAuthService.token.access_token;
    OAuthService.saveAppModules(OAuthService.token.appModules);
    OAuthService.saveLanguage(OAuthService.token.lang);
    OAuthService.saveRoles(OAuthService.token.roles);
    this.translate.use(OAuthService.token.langCode);
    this.statusSubject.next(true);
  }

  getStatusObservable(): Observable<boolean> {
    if (!this.statusObservable) {
      this.statusObservable = observableFrom(this.statusSubject);
    }
    return this.statusObservable;
  }

  isLoggedIn(): boolean {
    const token = OAuthService.token;
    return token !== null;
  }

  isRememberMe(): boolean {
    return this.cookieService.get(this.REMEMBER_ME_COOKIE) === 'true';
  }

  emailRemember(): string {
    let email = '';
    if (this.isRememberMe()) {
      email = this.cookieService.get(this.EMAIL_COOKIE);
    }
    return email;
  }

  verifyMFA (code: string, callback:any) {
    const body = "";
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      'Authorization': 'Basic ' + btoa('angularClient:nowit346346')
    });

    return this.http.post(environment.url.api + 'mfa/verify/' + code + '/' + this.phone, body, {headers})
               .subscribe( data => {
               if (data) {
                 let d = new Date();
                 d.setDate(d.getDate() + 30);
                 let options = { secure: true, expires: d, sameSite: "Strict"};
                 // Validated user to be stored in cookies
                 let userValidated = {username:this.moduleService.getUsername(), date:d};
                 let authenticatedUsers_string = this.cookieService.get(this.USERNAME_COOKIE)
                 let authenticatedUsers_array = [];
                 if(authenticatedUsers_string){
                   authenticatedUsers_array = JSON.parse(authenticatedUsers_string);
                   // The cookies already had users stored
                   // Now we verify that the user is not already stored
                   let userFound = false;
                   for(const element of authenticatedUsers_array){
                     if(element.username == this.username){
                       userFound = true;
                       break;
                     }
                   }
                   if(!userFound){
                     authenticatedUsers_array.push(userValidated);
                   }
                 }
                 // Initializes array of Validated Users to be stored in cookies
                 else{
                    authenticatedUsers_array = [userValidated];
                 }

                 if(userValidated.username){
                   authenticatedUsers_string = JSON.stringify(authenticatedUsers_array);
                   this.cookieService.put(this.USERNAME_COOKIE,authenticatedUsers_string, options);
                 }
               }
                   callback(data);
     }, (error: Response) => {
          callback(false);
       });
  }


  mfa(phone:string, callback): any {
    if (this.moduleService.getPhone() == null)
      this.moduleService.setPhone(phone);
    this.phone = phone;
    const body = "";
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      'Authorization': 'Basic ' + btoa('angularClient:nowit346346')
    });


    return this.http.post<any>(environment.url.api + 'mfa/' + phone, body, {headers})
      .subscribe(data => {
        console.log(data);
        callback(data);
      });
  }

  login(email: string, password: string, remember: boolean): Observable<any> {
  this.username = email;
    if (remember) {
      this.cookieService.put(this.REMEMBER_ME_COOKIE, 'true');
      this.cookieService.put(this.EMAIL_COOKIE, email);
    } else {
      this.cookieService.remove(this.REMEMBER_ME_COOKIE);
      this.cookieService.remove(this.EMAIL_COOKIE);
    }
    const observable: Observable<any> = new Observable(observer => {

      password = encodeURIComponent(password);

      const body = `grant_type=password&client_id=angularClient&username=${email}&password=${password}&mfaCode=${null}`;

      const headers = new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Authorization': 'Basic ' + btoa('angularClient:nowit346346')
      });
      this.http.post(environment.url.authUrl + 'oauth/token', body, { headers })
        .subscribe((data: any) => {
          // login ok
          OAuthService.token = data;
          // IF remember me is true, we save refresh_token on local storage
          if (remember) {
            OAuthService.refresh_token = OAuthService.token.refresh_token;
          }

          OAuthService.access_token = OAuthService.token.access_token;
          OAuthService.saveAppModules(OAuthService.token.appModules);
          OAuthService.saveLanguage(OAuthService.token.lang);
          OAuthService.saveLanguageCode(OAuthService.token.langCode);
          OAuthService.saveRoles(OAuthService.token.roles);
          this.statusSubject.next(true);
          observer.next(OAuthService.token);
          this.translate.use(OAuthService.token.langCode);
        },
        (error: any) => {
          if (error.error_description === 'invalid_username_or_password') {
            error.error_description = 'Login failed. Invalid username or password';
          }
          observer.error(error);
        });
    });

    return observable;
  }




  clearStorage() {
    OAuthService.token = null;
  }

  saveStorage() {
    this.storage.store('access_token', OAuthService.token.access_token);
    this.storage.store('appModules', OAuthService.token.appModules);
  }

  getRefreshTokenFromLS() {
    this.storage.retrieve('refresh_token');
  }

  logout(refreshToken = null, redirectToLogin = false) {
    this.globalFlagsService.setUserLogged(false);
    localStorage.clear();
    if (refreshToken) {
      console.log('Session expired. Please login again');
      OAuthService.access_token = null;
      OAuthService.refresh_token = null;
      if (redirectToLogin)
        this.router.navigate(['/login']);
      this.statusSubject.next(false);
    } else {
      OAuthService.access_token = null;
      OAuthService.refresh_token = null;
      this.statusSubject.next(false);
    }
  }

    saveDownloadToken (token) {
      OAuthService.downloadToken = token;
    }

    static getDownloadToken () :string {
      return OAuthService.downloadToken;
    }
}


